import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'

export const Route = createFileRoute('/_authenticated/workspaces/$subscriptionId/plan/downgrade/confirm')({
  beforeLoad({ params: { subscriptionId } }) {
    throw redirect({
      to: AppRoute.SubscriptionDowngradeSurvey,
      search: { step: 'confirm' },
      params: { subscriptionId },
    })
  },
})
